import React, { type CSSProperties } from 'react';
import cn from 'classnames';
import { Loader } from '@lt/components/icons-react/rebrand';
import styles from './spinner.module.css';

interface Props {
  size?: number;
  className?: string;
}

export const Spinner = ({ size = 30, className = '' }: Props) => (
  <Loader
    style={{ '--size': `${size}px` } as CSSProperties}
    className={cn(className, styles.container)}
  />
);
